/**
 * Returns the closest number of a number list. If no value is found, the current number is returned.
 * @param possibleNumbers The list of available numbers.
 * @param currentNumber The current number.
 * @param direction The direction to search. If `0` the closest number in both directions will be returned.
 */
export function findClosestNumber(possibleNumbers: Iterable<number>, currentNumber: number, direction: -1 | 0 | 1 = 0): number {
  // Just to make sure
  const dir = Math.sign(direction);

  let result = currentNumber;
  let diff = Number.MAX_VALUE;

  for (const p of possibleNumbers) {
    const d = p - currentNumber;

    if (direction === 0 || Math.sign(d) === dir) {
      const abs = Math.abs(d);

      if (abs < diff) {
        diff = abs;
        result = p;
      }
    }
  }

  return result;
}
